import { Link } from "react-router-dom";

const NotFound = () => {
    return (
        <div className="flex flex-col items-center justify-center h-screen text-center">
            <h1 className="text-4xl font-roboto-mono font-bold text-red-600">404 - Page Not Found</h1>
            <p className="mt-4 text-lg">Oops! The page you're looking for doesn't exist.</p>
            <Link to="/" className="mt-6 px-4 py-2 bg-dark text-white rounded-none hover:bg-dark">
                Go to Home
            </Link>
        </div>
    );
};

export default NotFound;
